<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import type { IChannelDTO } from "../../services/DTO";
  import Button from "../Button.svelte";
  import ClfDropdown from "../Form/Fields/Dropdown/ClfDropdown.svelte";
  import Input from "../Form/Fields/Input.svelte";
  import FormField from "../Form/FormField.svelte";
  import Icon from "../Icon.svelte";

  export let channels: IChannelDTO[] = [];
  export let entityId: number = 0;

  let wipChannel: IChannelDTO = {} as IChannelDTO;

  $: isNew =
    wipChannel == null || wipChannel.oid == null || wipChannel.oid == 0;

  $: canSubmit =
    wipChannel != null &&
    wipChannel.clfChannelTypeId != null &&
    wipChannel.value != "";

  const dispatch = createEventDispatcher();

  function onLoad() {
    dispatch("load", { entityId: entityId });
  }

  function onEdit(channel: IChannelDTO) {
    wipChannel = Object.assign({}, channel);
  }

  function onSave() {
    let channel = {
      oid: wipChannel.oid,
      entityId: entityId,
      clfChannelTypeId: wipChannel.clfChannelTypeId,
      description: wipChannel.description,
      value: wipChannel.value,
    } as IChannelDTO;
    dispatch("save", channel);
    wipChannel = {} as IChannelDTO;
  }

  function onCancel() {
    wipChannel = {} as IChannelDTO;
  }

  function onDelete(channel: IChannelDTO) {
    dispatch("delete", channel);
  }

  onMount(() => onLoad());
</script>

<div class="columns">
  <div class="column is-9">
    {#each channels as channel}
      <div class="box" style="margin-top:1rem;">
        <div class="channel-icons">
          {#if channel.ownerUserId != 1}
          <Icon
            name="edit"
            customRealIconStyle="font-size:18px;width:18px;"
            on:click={(_) => onEdit(channel)}
          />
          <Icon
            name="delete"
            customRealIconStyle="font-size:18px;width:18px;"
            on:click={(_) => onDelete(channel)}
          />
          {/if}
        </div>
        <div class="channel-data">
          <span class="channel-type">{channel.channelTypeDescription}</span>
          {#if !!channel.description}
            &nbsp;&mdash;&nbsp;
            <span class="channel-description">{channel.description}</span>
          {/if}
          <br />
          <span class="channel-value">{channel.value}</span>
        </div>
      </div>
    {/each}
  </div>
  <div class="column is-3">
    <div class="box" style="margin-top:1rem;">
      {#if isNew}
        <h1 class="subtitle">Nuovo Recapito</h1>
      {:else}
        <h1 class="subtitle">Modifica Recapito</h1>
      {/if}

      <FormField>
        <ClfDropdown
          name="Tipologia"
          schema="CHANNELTYP"
          required={false}
          clearVisible={false}
          bind:value={wipChannel.clfChannelTypeId}
        />
      </FormField>
      <FormField>
        <Input
          name="Recapito"
          placeholder=""
          required={false}
          bind:value={wipChannel.value}
        />
      </FormField>
      <FormField>
        <Input
          name="Descrizione"
          placeholder=""
          required={false}
          bind:value={wipChannel.description}
        />
      </FormField>
      <FormField>
        <div class="has-text-centered" style="margin-top: 2rem;">
          {#if isNew}
            <Button klass="is-primary" disabled={!canSubmit} on:click={onSave}
              >Aggiungi</Button
            >
          {:else}
            <Button klass="is-primary" disabled={!canSubmit} on:click={onSave}
              >Salva</Button
            >
            <Button klass="is-light" on:click={onCancel}>Annulla</Button>
          {/if}
        </div>
      </FormField>
    </div>
  </div>
</div>

<style>
  .channel-icons {
    display: inline-block;
    vertical-align: top;
  }
  .channel-data {
    display: inline-block;
    margin-left: 2rem;
  }
  .channel-type {
    font-weight: bold;
  }
  .channel-description {
    color: #999;
    font-style: italic;
  }
</style>
